import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { FIXED_INDENTS } from 'vars/fixed-indents'

import { ButtonCorners } from 'atoms/Button'
import { InlineCloseButton } from 'atoms/Button/Templates'
import { COLOR } from 'vars/color'
import { INDENTS } from 'vars/indents'

export interface ICloseButtonPopupProps extends IButtonProps {
  withPosterUrl?: boolean
  handleClose?: (e) => void
  paddings?: INDENTS[] | FIXED_INDENTS[]
}

export const CloseButtonPopup = ({
  withPosterUrl,
  handleClose,
  paddings,
}: ICloseButtonPopupProps): JSX.Element => {
  const paddingsButton = withPosterUrl ? [INDENTS.INDENT_10] : paddings
  const corners = withPosterUrl
    ? ButtonCorners.CORNERS_ROUND
    : ButtonCorners.CORNERS_10
  const backgroundColorDefault = withPosterUrl
    ? COLOR.OVERLAY_DEFAULT
    : COLOR.TRANSPARENT

  return (
    <InlineCloseButton
      onClick={handleClose}
      paddings={paddingsButton}
      corners={corners}
      backgroundColorDefault={backgroundColorDefault}
    />
  )
}
